export default __webpack_public_path__ + "static/media/trash.9526151d.svg";